export default build =>
    build.mutation({
        query(payload) {
            console.log("payload",payload)
            return {
                url: '/staff/createStaff',
                method: 'POST',
                body: payload,
               
            };
        },
        invalidatesTags: ['allStaff'],
    })
